import React from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-modal'

import Icon from 'Pods/Shared/Icon/Icon'
import axios from 'axios'

class NextStepsOverlay extends React.Component {
  constructor() {
    super()

    this.state = {
      data: {},
      isDataFetched: false,
    }

    this.onFetchSuccess = this.onFetchSuccess.bind(this)
  }

  componentDidMount() {
    this.fetchData()
  }

  fetchData() {
    axios.get(`/api/internal/users/${this.props.userId}/instructions`).then(this.onFetchSuccess)
      .catch((error) => {})
  }

  onFetchSuccess(response) {
    this.setState({ data: response.data.instructions, isDataFetched: true })
  }

  render() {
    const instructionsDetails = {
      Publisher: { icon: 'upload', link: '/profile/upload/model' },
      'Batch uploader': { icon: 'boxes', link: '/profile/upload/batch' },
      'Seller handbook': { icon: 'book', link: 'https://help.cgtrader.com' },
      '3D Projects listing page': { icon: 'pencil-ruler', link: '/3d-modeling-jobs/browse' },
      'Account settings': { icon: 'cog', link: '/profile/settings' },
      'Payment agreement page': { icon: 'handshake-alt', link: '/profile/payment_agreements' },
      'Analytics About page': { icon: 'chart-bar', link: '/profile/analytics/about' },
    }

    const searchInstruction = Object.values(this.state.data).find(instruction => instruction.title === 'Empty search')
    const instructionsWithoutSearch = Object.values(this.state.data).filter(instruction => instruction.title !== 'Empty search')

    return (
      <Modal
        isOpen={this.props.modalIsOpen}
        shouldCloseOnOverlayClick
        onRequestClose={this.props.closeModal}
        contentLabel="Modal"
        ariaHideApp={false}
        className={{
          base: 'overlay-modal--container',
          afterOpen: 'overlay-modal--container_after-open',
          beforeClose: 'overlay-modal--container_before-close',
        }}
        overlayClassName={{
          base: 'overlay-modal--background overlay-modal--background-dark overlay-modal--visible-menu',
          afterOpen: 'overlay-modal--background_after-open',
          beforeClose: 'overlay-modal--background_before-close',
        }}
      >
        {this.state.isDataFetched && (
          <div className="overlay-modal overlay-modal--transparent overlay-modal--next-steps">
            <button className="btn btn-transparent overlay-modal--close" onClick={this.props.closeModal}>
              Close <Icon type={['fal', 'times']} color="white" className="ml-5" />
            </button>

            {searchInstruction && (
              <div className="instruction instruction--search">
                <Icon type={['fal', 'long-arrow-up']} size="2x" notSpaced />
                <div className="heading-20 heading-white u-mt10 instruction-heading">{searchInstruction.subtitle}</div>
                <p className="text-light text-white">{searchInstruction.text}</p>
              </div>
            )}

            <div className="overlay-modal--content u-text-center">
              <div className={`content-wrapper ${searchInstruction ? 'content-wrapper--spaced-top' : ''}`}>
                <div className="overlay-heading">
                  <h2 className="heading-24 heading-white u-m0 u-mb10">Boost your experience</h2>
                  <p className="overlay-modal__subtitle text-light">Are you taking advantage of everything CGTrader has to offer?</p>
                </div>

                <div className="instructions-container">
                  {instructionsWithoutSearch.map((instruction) => (
                    <div className="instruction" key={instruction.title}>
                      <a href={instructionsDetails[instruction.title].link} className="text-undecorated">
                        <span className="fa-layers fa-fw fa-10x">
                          <Icon type={['fas', 'hexagon']} className="fa-rotate-270" notSpaced />
                          <Icon type={['fas', instructionsDetails[instruction.title].icon]} color="white" transform="shrink-11" notSpaced />
                        </span>
                        <div className="heading-20 heading-white u-mb10 instruction-heading">{instruction.subtitle}</div>
                        <p className="text-light text-white">{instruction.text}</p>
                      </a>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        )}
      </Modal>
    )
  }
}

NextStepsOverlay.propTypes = {
  modalIsOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  userId: PropTypes.number.isRequired,
}

export default NextStepsOverlay
